import { render, staticRenderFns } from "./AddCompanyToGroupModal.vue?vue&type=template&id=b6cad83e&"
import script from "./AddCompanyToGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyToGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyToGroupModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports